<template>
  <div @scroll="updateActiveCategory" class="menu">
    <transition name="fade">
      <DateAndTimeModal
        v-if="dateAndTimeModalIsOpen"
        @closeModal="toggleDateAndTimeModal"
        @openDiscountModal="openDiscountModal"
        @addDeepLinkItemToCart="addDeepLinkItemToCart"
      />
    </transition>
    <transition name="fade">
      <PendingDiscountModal
        v-if="pendingDiscountModalIsOpen"
        @closeModal="togglePendingDiscountModal"
        :discountData="pendingDiscountData"
      />
    </transition>
    <transition name="slide">
      <CartModal
        v-if="cartIsOpen"
        @closeModal="toggleCartViewModal"
        @checkoutClicked="toggleCartViewModal"
        @openUpsellItem="openUpsellItem"
        @openWithAddons="openEditWithAddons"
      />
    </transition>
    <transition name="slide">
      <WithAddons
        v-if="withAddonsModalIsOpen"
        @closeModal="toggleWithAddonsModal"
        :itemData="itemData"
        :normalizedAddons="normalizedAddons"
        :mode="itemModalMode"
        :editItemData="editItemData"
        @getFavStatus="getFavStatus"
      />
    </transition>
    <HeroView />
    <LoaderView v-if="!menus || showLoader" :showLoader="showLoader" />
    <div v-if="checkIfMenuVisible" class="menuWrapper">
      <div class="categories">
        <div
          v-if="
            getAvailableMenus &&
            getAvailableMenus.length > 1 &&
            !this.branding?.display_options?.collapse_menu_categories
          "
          class="topMenusWrapper"
        >
          <swiper
            :navigation="true"
            :slidesPerView="'auto'"
            :slidesPerGroup="1"
            :spaceBetween="15"
            :modules="modules"
            @swiper="onSwiper"
            class="swiperGradientRight"
          >
            <swiper-slide
              :class="{ selectedMenu: selectedMenuIndex == index }"
              @click="changeMenu(index)"
              v-for="(menu, index) in getAvailableMenus"
              :key="menu.menu_id"
            >
              <p class="topCategory">{{ menu.name }}</p>
            </swiper-slide>
            <div v-if="!swiperSlideData.isBeginning" class="gradientLeft"></div>
            <div v-if="!swiperSlideData.isEnd" class="gradientRight"></div>
          </swiper>
        </div>
        <div
          :style="{
            display: (branding && branding.category_placement == 'top') || innerWidth <= 768 ? 'flex' : 'none',
          }"
          class="topCategoriesWrapper"
        >
          <swiper
            :navigation="true"
            :slidesPerView="'auto'"
            :slidesPerGroup="1"
            :spaceBetween="15"
            :modules="modules"
            @slideChange="getActiveSlide($event)"
            @swiper="onSwiper"
            class="mySwiper"
          >
            <swiper-slide
              v-for="(topCategory, index) in getTopCategories"
              :key="topCategory.category_id"
              @click="scrollToCategory(topCategory.category_id, index)"
              :class="{ active: activeCategoryIndex == index }"
            >
              <p class="topCategory">{{ topCategory.name }}</p>
            </swiper-slide>
            <div v-if="!swiperSlideData.isBeginning" class="gradientLeft"></div>
            <div v-if="!swiperSlideData.isEnd" class="gradientRight"></div>
          </swiper>
          <div class="inputWrapper">
            <svg class="searchIcon" xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19">
              <path
                id="Search"
                d="M16.912,17.814l-4.279-4.279a7.686,7.686,0,1,1,.9-.9l4.279,4.279a.637.637,0,0,1-.9.9ZM1.274,7.677a6.4,6.4,0,1,0,6.4-6.4A6.409,6.409,0,0,0,1.274,7.677Z"
                transform="translate(0.5 0.5)"
                fill="#292828"
                stroke="rgba(0,0,0,0)"
                stroke-miterlimit="10"
                stroke-width="1"
              />
            </svg>
            <input @keyup="searchItems()" v-model="search" class="searchInput" type="text" placeholder="Search Items" />
            <img v-if="search.length >= 3" class="clearSearch" @click="clearSearch" src="@/assets/icons/close.svg" />
          </div>
        </div>
        <div
          v-if="selectedStore && selectedStore.promo_text && selectedStore.promo_text != '' && !searchedItems"
          class="promoPart"
        >
          <p
            v-html="getPurifiedBody"
            :style="{
              backgroundColor: branding.dark_mode_enabled ? 'var(--background-color)' : '#FFFFFF',
              border: branding.dark_mode_enabled ? '1px solid var(--border-color)' : 'none',
            }"
          ></p>
        </div>
        <div
          class="menuGrid"
          :style="{
            'grid-template-columns': branding && branding.category_placement == 'top' ? '1fr' : '200px 1fr',
          }"
        >
          <div
            :style="{
              display: branding && branding.category_placement == 'side' ? 'block' : 'none',
            }"
            class="leftCategoriesWrapper"
          >
            <div class="leftCategories">
              <div class="inputWrapper">
                <svg class="searchIcon" xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19">
                  <path
                    id="Search"
                    d="M16.912,17.814l-4.279-4.279a7.686,7.686,0,1,1,.9-.9l4.279,4.279a.637.637,0,0,1-.9.9ZM1.274,7.677a6.4,6.4,0,1,0,6.4-6.4A6.409,6.409,0,0,0,1.274,7.677Z"
                    transform="translate(0.5 0.5)"
                    fill="#292828"
                    stroke="rgba(0,0,0,0)"
                    stroke-miterlimit="10"
                    stroke-width="1"
                  />
                </svg>
                <input
                  @keyup="searchItems()"
                  v-model="search"
                  class="searchInput"
                  type="text"
                  placeholder="Search Items"
                />
                <img
                  v-if="search.length >= 3"
                  class="clearSearch"
                  @click="clearSearch"
                  src="@/assets/icons/close.svg"
                />
              </div>
              <div
                v-for="category in getAvailableMenus[selectedMenuIndex].categories"
                :key="category.category_id"
                class="leftCategory"
                @click="scrollToCategory(category.category_id)"
              >
                <div class="categoryLine" :class="{ leftSelected: activeCategoryId == category.category_id }">
                  <a
                    v-if="
                      branding.display_options?.category_image?.show &&
                      category.name === branding.display_options?.favorites_category?.title
                    "
                    class="favorite"
                    :style="{ backgroundColor: branding.dark_mode_enabled ? 'var(--background-color)' : '#FFFFFF' }"
                  >
                    <svg
                      class="favoriteFill categoryImage"
                      xmlns="http://www.w3.org/2000/svg"
                      width="30"
                      height="30"
                      viewBox="0 0 30 30"
                    >
                      <path
                        id="heart-fill"
                        d="M46.654,0A7.425,7.425,0,0,0,39.83,4.53,7.422,7.422,0,0,0,33.006,0C27.9,0,24.83,
        4.864,24.83,8.874c0,6.719,15,16.959,15,16.959s15-10.238,15-16.958C54.83,4.864,51.758,0,46.654,0Z"
                        transform="translate(-24.83)"
                        fill="#010101"
                      />
                    </svg>
                  </a>
                  <img
                    v-if="
                      branding.display_options?.category_image?.show &&
                      category.name !== branding.display_options?.favorites_category?.title
                    "
                    class="categoryImage"
                    :style="{
                      'border-radius': branding.display_options?.category_image.type == 'image' ? '50%' : '0',
                      'object-fit': branding.display_options?.category_image.type == 'image' ? 'cover' : 'contain',
                    }"
                    :src="category.image_urls?.thumbnail"
                    :alt="category.name"
                  />
                  <p>{{ category.name }}</p>
                </div>
                <div
                  class="leftSubCategory"
                  v-for="subCategory in category.categories"
                  :key="subCategory.category_id"
                  @click.stop="scrollToCategory(subCategory.category_id)"
                  :class="{ leftSelected: activeSubCategoryId == subCategory.category_id }"
                >
                  <div class="categoryLine">
                    <img
                      v-if="branding.display_options?.category_image?.show"
                      :style="{
                        'border-radius': branding.display_options?.category_image.type == 'image' ? '50%' : '0',
                        'object-fit': branding.display_options?.category_image.type == 'image' ? 'cover' : 'contain',
                      }"
                      :src="subCategory.image_urls?.thumbnail"
                      :alt="subCategory.name"
                    />
                    <p>{{ subCategory.name }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="categoryList">
            <div v-if="searchedItems">
              <div class="searchTopPart">
                <h4 class="searchResultText" v-if="searchedItems && searchedItems.length != 0">
                  {{ searchedItems.length }} results for '{{ search }}'
                </h4>
                <h4 class="searchResultText" v-if="searchedItems && searchedItems.length == 0">
                  No result for '{{ search }}'
                </h4>
                <a class="clear" @click="clearSearch" href="javascript:;">
                  <p>CLEAR SEARCH RESULTS</p>
                </a>
              </div>
              <div class="searchResults">
                <div
                  @click="
                    item.type == 'marketing'
                      ? openMarketingBox(item.url)
                      : item.variants[0]?.is_out_of_stock
                      ? null
                      : getItemData(item, item.category, 'add')
                  "
                  class="item"
                  :style="{ backgroundColor: branding.dark_mode_enabled ? 'var(--background-color)' : '#FFFFFF' }"
                  v-for="item in searchedItems"
                  :key="item.item_id"
                >
                  <ItemCell
                    :item="item"
                    :category="item.category"
                    @getItemData="getItemData"
                    @changeQty="changeQty"
                    :orderData="orderData"
                    :qtyLoading="qtyLoading"
                    :selectedItemId="selectedItemId"
                    :quickAddLoadingItemId="quickAddLoadingItemId"
                    :fillScreenAnimation="fillScreenAnimation"
                    :fillScreenItemId="fillScreenItemId"
                    :flyToCardItemId="flyToCardItemId"
                  />
                </div>
              </div>
            </div>
            <div v-if="!searchedItems">
              <div v-if="selectedStore && getFilteredSuggestions?.length != 0" class="suggestions">
                <div v-if="branding.suggestions" class="suggestionGroupHeader">
                  <h2>{{ branding.suggestions.main_header }}</h2>
                  <div ref="filterDropdown" v-if="suggestions.length > 1" class="inputWrapper">
                    <svg
                      class="arrow"
                      width="12"
                      height="9"
                      viewBox="0 0 12 9"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5.53558 7.93101L0.221517 2.61692C-0.0347764 2.36063 -0.0347764 1.94511 0.221517 1.68885L0.841317 1.06904C1.09717 0.813189 1.51184 0.812697 1.7683 1.06795L5.99963 5.27946L10.2309 1.06795C10.4874 0.812697 10.9021 0.813189 11.1579 1.06904L11.7777 1.68885C12.034 1.94514 12.034 2.36065 11.7777 2.61692L6.46368 7.93101C6.20739 8.18728 5.79188 8.18728 5.53558 7.93101Z"
                        fill="#171717"
                      />
                    </svg>
                    <div @click="toggleFilterDropdown" class="customSelect">
                      <p>{{ selectedSuggestionFilter }}</p>
                    </div>
                    <div
                      v-if="filterDropdownIsOpen"
                      class="dropdown"
                      :style="{ backgroundColor: branding.dark_mode_enabled ? 'var(--background-color)' : '#FFFFFF' }"
                    >
                      <div
                        @click="selectFilter('See All')"
                        :class="{
                          selected: 'See All' == selectedSuggestionFilter,
                        }"
                        class="dropdownItem"
                      >
                        See All
                      </div>
                      <div
                        v-for="suggestion in suggestions"
                        :key="suggestion"
                        @click="selectFilter(suggestion.display_name)"
                        class="dropdownItem"
                        :class="{
                          selected: suggestion.display_name == selectedSuggestionFilter,
                        }"
                      >
                        {{ suggestion.display_name }}
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-for="suggestion in getFilteredSuggestions"
                  :key="suggestion"
                  class="suggestion"
                  :style="{ backgroundColor: branding.dark_mode_enabled ? 'var(--background-color)' : '#FFFFFF' }"
                >
                  <div v-if="suggestion.items && suggestion.items.length != 0">
                    <div class="suggestionHeaderWrapper">
                      <p class="suggestionHeader">
                        <span v-if="suggestion.type == 'temperature'"
                          >It's {{ temperature }} °F in {{ selectedStore.city }}.</span
                        >
                        {{ suggestion.prompt }}
                      </p>
                      <a
                        @click="getSurpriseSuggestions"
                        v-if="suggestion.type == 'surprise'"
                        class="surpriseButton"
                        href="javascript:;"
                      >
                        <p>SURPRISE ME</p>
                      </a>
                    </div>
                    <swiper
                      :navigation="true"
                      :slidesPerView="'auto'"
                      :spaceBetween="15"
                      :slidesOffsetBefore="windowWidth > 768 ? 0 : 20"
                      :slidesOffsetAfter="windowWidth > 768 ? 0 : 20"
                      :modules="modules"
                      class="mySwiper"
                    >
                      <swiper-slide
                        @click="
                          item.type == 'marketing'
                            ? openMarketingBox(item.url)
                            : item.variants[0]?.is_out_of_stock
                            ? null
                            : getItemData(item, getCategory(item.category_id), 'add')
                        "
                        v-for="item in suggestion.type == 'surprise' ? surpriseSuggestions : suggestion.items"
                        :key="item.item_id"
                        class="suggestionItem"
                        :class="{ outOfStockItem: item.variants[0]?.is_out_of_stock }"
                        :style="{
                          backgroundColor: branding.dark_mode_enabled ? 'var(--background-color)' : '#FFFFFF',
                        }"
                      >
                        <div v-if="checkIfImageIsVisible" class="itemImageWrapper">
                          <img
                            :src="item.image_urls?.thumbnail"
                            :alt="item.name"
                            loading="lazy"
                            :class="{ outOfStock: item.variants[0]?.is_out_of_stock }"
                          />
                        </div>
                        <div class="suggestionItemInfo">
                          <p class="suggestionItemName">{{ item.name }}</p>
                          <p class="suggestionItemDescription">
                            {{ item.short_desc }}
                          </p>
                          <p v-if="checkIfPriceVisible(item.variants[0].display_price)" class="suggestionItemPrice">
                            {{ formatPrice(item.variants[0].display_price) }}
                          </p>
                        </div>
                      </swiper-slide>
                    </swiper>
                  </div>
                </div>
              </div>
              <div
                class="category"
                :style="{
                  'scroll-margin-top': branding.category_placement == 'top' ? '80px' : '60px',
                }"
                v-for="(category, index) in getAvailableMenus[selectedMenuIndex].categories"
                :key="category.category_id"
                :id="category.category_id"
              >
                <div class="categoryInfo" :class="{ parentCategory: category.categories?.length != 0 }">
                  <div v-if="branding?.display_options?.show_category_headers" class="categoryImageWrapper">
                    <img
                      class="categoryMainImage"
                      :src="getCategoryImage(category.image_urls.standard)"
                      :alt="category.name"
                    />
                  </div>
                  <h2 v-if="!branding?.display_options?.hide_category_names !== false" class="categoryName">
                    {{ category.name }}
                  </h2>
                  <p v-if="category.short_desc" class="categoryDescription">
                    {{ category.short_desc }}
                  </p>
                </div>
                <div v-if="category.categories?.length != 0" class="subCategories">
                  <div
                    class="category"
                    v-for="(subCategory, index) in category.categories"
                    :key="subCategory.category_id"
                    :id="subCategory.category_id"
                  >
                    <div class="categoryInfo">
                      <h2 class="categoryName">{{ subCategory.name }}</h2>
                      <p v-if="subCategory.short_desc" class="categoryDescription">
                        {{ subCategory.short_desc }}
                      </p>
                    </div>
                    <div class="items">
                      <div
                        @click="
                          item.type == 'marketing'
                            ? openMarketingBox(item.url)
                            : item.variants[0]?.is_out_of_stock
                            ? null
                            : getItemData(item, subCategory, 'add')
                        "
                        class="item"
                        v-for="item in subCategory.items"
                        :key="item.item_id"
                      >
                        <ItemCell
                          :item="item"
                          :category="subCategory"
                          :index="index"
                          @getItemData="getItemData"
                          @changeQty="changeQty"
                          :orderData="orderData"
                          :qtyLoading="qtyLoading"
                          :selectedItemId="selectedItemId"
                          :quickAddLoadingItemId="quickAddLoadingItemId"
                          :fillScreenAnimation="fillScreenAnimation"
                          :fillScreenItemId="fillScreenItemId"
                          :flyToCardItemId="flyToCardItemId"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="items">
                  <div
                    @click="
                      item.type == 'marketing'
                        ? openMarketingBox(item.url)
                        : item.variants[0]?.is_out_of_stock
                        ? null
                        : getItemData(item, category, 'add')
                    "
                    class="item"
                    v-for="item in category.items"
                    :key="item.item_id"
                  >
                    <ItemCell
                      :item="item"
                      :category="category"
                      :index="index"
                      @getItemData="getItemData"
                      @changeQty="changeQty"
                      :orderData="orderData"
                      :qtyLoading="qtyLoading"
                      :selectedItemId="selectedItemId"
                      :quickAddLoadingItemId="quickAddLoadingItemId"
                      :fillScreenAnimation="fillScreenAnimation"
                      :fillScreenItemId="fillScreenItemId"
                      :flyToCardItemId="flyToCardItemId"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="emptyMenu">
      <p>
        There is no active menu for the selected date and time. <br />
        <a class="clear" @click="toggleDateAndTimeModal" href="javascript:;">
          <p>CHANGE ORDER DATE AND TIME</p>
        </a>
      </p>
    </div>
    <FooterView />
  </div>
</template>

<script>
import formattingMixins from '@/mixins/formattingMixins'
import normalizeAddons from '@/mixins/normalizeAddons'
import trackMainRoutes from '@/mixins/trackMainRoutes'
import menuItemImageVisibility from '@/mixins/menuItemImageVisibility'
import fullStoryMixins from '@/mixins/fullStoryMixins'

import { mapState, mapMutations } from 'vuex'

import HeroView from '@/components/Main/Layout/HeroView.vue'
import FooterView from '@/components/Main/Layout/FooterView.vue'
import LoaderView from '@/components/Loaders/LoaderView.vue'
import DateAndTimeModal from '@/components/Modals/StoreModals/DateAndTimeModal.vue'
import WithAddons from '@/components/Modals/ItemModals/WithAddons.vue'
import CartModal from '@/components/Modals/CartModals/CartModal.vue'
import PendingDiscountModal from '@/components/Modals/StoreModals/PendingDiscountModal.vue'
import ItemCell from '@/components/Main/Menu/ItemCell.vue'

import { Swiper, SwiperSlide } from 'swiper/vue'
import 'swiper/css'
import { Navigation } from 'swiper'
import 'swiper/css/navigation'
import moment from 'moment'

import DOMPurify from 'dompurify'

import menusApi from '@/api/menusApi'
import ordersApi from '@/api/ordersApi'
import externalApi from '@/api/externalApi'
import customersApi from '@/api/customersApi'

export default {
  data() {
    return {
      storeId: null,
      menus: null,
      modules: [Navigation],
      activeCategoryIndex: 0,
      activeCategoryId: null,
      activeSubCategoryId: null,
      search: '',
      searchedItems: null,
      dateAndTimeModalIsOpen: true,
      withAddonsModalIsOpen: false,
      itemData: null,
      normalizedAddons: null,
      showLoader: false,
      swiperSlideData: {
        activeSlide: 0,
        isBeginning: true,
        isEnd: false,
      },
      itemModalMode: 'add',
      editItemData: null,
      swiper: null,
      innerWidth: window.innerWidth,
      cartViewIsOpen: false,
      suggestions: [],
      temperature: null,
      selectedSuggestionFilter: 'See All',
      filterDropdownIsOpen: false,
      favorites: null,
      selectedMenuIndex: 0,
      surpriseSuggestions: [],
      slidesPerView: 3,
      pendingDiscountModalIsOpen: false,
      pendingDiscountData: null,
      selectedItemId: null,
      selectedItemName: null,
      selectedItemIndex: null,
      removeItemModalIsOpen: false,
      qtyLoading: false,
      quickAddLoadingItemId: null,
      fillScreenAnimation: false,
      fillScreenItemId: null,
      flyToCardItemId: null,
      windowWidth: window.innerWidth,
      baseTitle: document.title,
    }
  },
  components: {
    HeroView,
    Swiper,
    SwiperSlide,
    LoaderView,
    DateAndTimeModal,
    WithAddons,
    FooterView,
    CartModal,
    PendingDiscountModal,
    ItemCell,
  },
  watch: {
    loggedIn() {
      if (this.loggedIn) {
        this.getFavorites()
      }
    },
    selectedStore() {
      this.getTemperature()
      this.updateTitle()
    },
    selectedHour() {
      this.getMenus()
    },
    orderData(newVal, oldVal) {
      if (newVal && oldVal == null && this.menus) {
        // if there is an active order and deepLinkItemId, add it to the cart
        let deepLinkItemId = localStorage.getItem('deepLinkItemId')
        if (this.orderData && deepLinkItemId) {
          this.addDeepLinkItemToCart()
        }
      }
    },
    menus(newVal, oldVal) {
      if (newVal && oldVal == null && this.orderData) {
        // if there is an active order and deepLinkItemId, add it to the cart
        let deepLinkItemId = localStorage.getItem('deepLinkItemId')
        if (this.menus && deepLinkItemId) {
          this.addDeepLinkItemToCart()
        }
      }
    },
  },
  mixins: [formattingMixins, normalizeAddons, menuItemImageVisibility, fullStoryMixins],
  // spread operator used because beforeRouteLeave is not working with the mixin
  ...trackMainRoutes,
  computed: {
    ...mapState([
      'storeConfig',
      'loggedIn',
      'selectedStore',
      'branding',
      'cartIsOpen',
      'selectedHour',
      'selectedDay',
      'dayAndTimeSelected',
      'cookies',
      'orderData',
    ]),
    getUpdatedFavorites() {
      return this.favorites
    },
    getAvailableMenus() {
      // filter out menus that dont have categories
      let availableMenus = this.menus.filter((menu) => menu.categories.length > 0)
      return availableMenus
    },
    getFilteredSuggestions() {
      if (this.selectedSuggestionFilter == 'See All') {
        return this.suggestions
      } else {
        return this.suggestions.filter(
          (suggestion) => suggestion.display_name == this.selectedSuggestionFilter && suggestion.enabled
        )
      }
    },
    quickAddable() {
      // if item has size
      if (this.normalizedAddons.sizes) {
        return false
        // if item has styles
      } else if (this.normalizedAddons.styles) {
        return false
        // if item has modifiers
      } else if (this.normalizedAddons.addOn.pick_lists.length > 0) {
        return false
      } else {
        return true
      }
    },
    getPurifiedBody() {
      // only allow br, strong, and a tags
      const allowedTags = ['br', 'strong', 'a']
      const allowedAttributes = ['href', 'target']
      const purifiedBody = DOMPurify.sanitize(this.selectedStore.promo_text, {
        ALLOWED_TAGS: allowedTags,
        ALLOWED_ATTR: allowedAttributes,
      })
      return purifiedBody
    },
    checkIfMenuVisible() {
      if (this.menus && this.getAvailableMenus) {
        let menusHaveCategories = this.getAvailableMenus.some((menu) => menu.categories.length > 0)
        if (this.getAvailableMenus.length != 0 && menusHaveCategories) {
          return true
        }
      }
      return false
    },
    getTopCategories() {
      const categories = []

      const selectedMenu = this.menus[this.selectedMenuIndex]
      for (const category of selectedMenu.categories) {
        if (category.categories && category.categories.length !== 0) {
          categories.push(...category.categories)
        } else {
          categories.push(category)
        }
      }

      return categories
    },
  },
  methods: {
    ...mapMutations([
      'SET_ORDER_DATA',
      'SET_TOASTER',
      'SET_CART_IS_OPEN',
      'SET_COOKIES',
      'SET_DAY_AND_TIME_SELECTED',
      'SET_SELECTED_DAY',
      'SET_SELECTED_HOUR',
      'SET_SELECTED_ADDRESS',
      'SET_ITEM_TOASTER',
      'SET_BUTTON_LOADER',
      'SET_LOGGED_IN',
      'SET_CUSTOMER_DATA',
      'SET_PHONE_VERIFIED',
    ]),
    getFavoriteCategory() {
      const favoritesCategory = this.branding?.display_options?.favorites_category

      if (favoritesCategory?.enabled) {
        if (this.favorites) {
          const selectedMenu = this.menus[this.selectedMenuIndex]
          if (selectedMenu) {
            const items = this.favorites.map((eachFavorite) => {
              const eachCategoryItem = selectedMenu.categories
                .find((eachCategory) => eachCategory.category_id === eachFavorite.cat_id)
                ?.items?.find((eachItem) => eachItem.item_id === eachFavorite.item_id)
              return eachCategoryItem
            })
            const favoriteItems = items.filter((each_item) => each_item !== undefined)
            return {
              name: favoritesCategory.title || 'Favorites',
              items: favoriteItems,
              category_id: 0,
              menu_id: selectedMenu?.menu_id,
              hours: selectedMenu?.hours,
              categories: [],
            }
          }
        }
      }
    },
    checkIfPriceVisible(price) {
      if ('hide_price_if_zero' in this.branding?.display_options) {
        if (price == 0 && this.branding?.display_options?.hide_price_if_zero) {
          return false
        }
      }
      return true
    },
    addDeepLinkItemToCart() {
      let deepLinkItemId = localStorage.getItem('deepLinkItemId')
      // find item in this.menus categories items
      let itemData = null
      let categoryId = null
      for (const menu of this.menus) {
        for (const category of menu.categories) {
          for (const item of category.items) {
            if (item.item_id == deepLinkItemId) {
              itemData = item
              categoryId = category.category_id
              break
            }
          }
        }
      }
      // if item is found, add it to the cart
      if (itemData) {
        this.getItemData(itemData, this.getCategory(categoryId), 'add', 'deepLink')
        localStorage.removeItem('deepLinkItemId')
      }
    },
    getCategoryImage(url) {
      return url.replace('600,450', '1200,900')
    },
    getCategory(id) {
      let categoryData
      this.menus.forEach((menu) => {
        menu.categories.forEach((category) => {
          if (category.category_id === id) {
            categoryData = category
          }
        })
      })
      if (!categoryData) {
        return { category_id: id }
      }
      return categoryData
    },
    getTotalQuantity(itemId) {
      let totalQuantity = 0
      let multipleItems = false

      for (let i = 0; i < this.orderData.order.items.length; i++) {
        const item = this.orderData.order.items[i]

        if (item.item_id === itemId) {
          totalQuantity += item.quantity

          if (totalQuantity > item.quantity) {
            multipleItems = true
          }
        }
      }
      return {
        totalQuantity,
        multipleItems,
      }
    },
    trackItemClicks(category, item) {
      window.dataLayer.push({ ecommerce: null }) // Clear the previous ecommerce object.
      window.dataLayer.push({
        event: 'view_item',
        ecommerce: {
          currency: 'USD',
          value: item.variants[0].price / 100,
          items: [
            {
              item_id: item.item_id,
              item_name: item.name,
              item_category: category.name || '',
              location_id: this.selectedStore.name,
              price: item.variants[0].price / 100,
            },
          ],
        },
      })
    },
    trackAddToCart(item) {
      window.dataLayer.push({ ecommerce: null }) // Clear the previous ecommerce object.
      window.dataLayer.push({
        event: 'add_to_cart',
        ecommerce: {
          currency: 'USD',
          value: item.variants[0].price / 100,
          items: [
            {
              item_id: item.item_id,
              item_name: item.name,
              price: item.variants[0].price / 100,
              location_id: this.selectedStore.name,
            },
          ],
        },
      })
    },
    getSurpriseSuggestions() {
      // find the suggestion with type 'surprise'
      let surprise = this.suggestions.find((suggestion) => suggestion.type == 'surprise')
      let randomItems = []
      // get 3 random items from the surprise suggestion.items and make sure they are not the same
      for (let i = 0; i < 3; i++) {
        let randomItem = surprise.items[Math.floor(Math.random() * surprise.items.length)]
        if (randomItems.includes(randomItem)) {
          i--
        } else {
          randomItems.push(randomItem)
        }
      }
      this.surpriseSuggestions = randomItems
    },
    openMarketingBox(url) {
      window.open(url, '_blank')
    },
    openDiscountModal(data) {
      this.pendingDiscountData = data
      this.togglePendingDiscountModal()
    },
    selectFilter(filter) {
      this.selectedSuggestionFilter = filter
      this.toggleFilterDropdown()
    },
    formatTime(time) {
      return moment(this.calculateTimeToHour(time), 'HH:mm:ss').format('h:mm A')
    },
    toggleDateAndTimeModal() {
      this.dateAndTimeModalIsOpen = !this.dateAndTimeModalIsOpen
    },
    toggleWithAddonsModal() {
      setTimeout(() => {
        this.fillScreenItemId = null
        this.fillScreenAnimation = false
      }, 800)
      this.withAddonsModalIsOpen = !this.withAddonsModalIsOpen
    },
    toggleFilterDropdown() {
      this.filterDropdownIsOpen = !this.filterDropdownIsOpen
    },
    toggleCartViewModal() {
      this.SET_CART_IS_OPEN(!this.cartIsOpen)
    },
    togglePendingDiscountModal() {
      this.pendingDiscountModalIsOpen = !this.pendingDiscountModalIsOpen
    },
    toggleRemoveItemModal() {
      this.removeItemModalIsOpen = !this.removeItemModalIsOpen
    },
    openEditWithAddons(item) {
      this.itemModalMode = 'edit'
      this.getItemData(item, this.getCategory(item.category_id), 'edit')
    },
    getActiveSlide(event) {
      this.swiperSlideData.activeSlide = event.activeIndex
      this.swiperSlideData.isBeginning = event.isBeginning
      this.swiperSlideData.isEnd = event.isEnd
    },
    getFavStatus() {
      this.getFavorites()
    },
    searchItems() {
      // scroll to top
      document.querySelector('.menu').scrollTo(0, 0)
      if (this.search.length == 0) {
        this.searchedItems = null
      }
      if (this.search.length > 2) {
        let searchResults = []
        this.menus[this.selectedMenuIndex].categories.forEach((category) => {
          if (category.categories?.length != 0) {
            category.categories.forEach((subCategory) => {
              subCategory.items.forEach((item) => {
                if (item.name?.toLowerCase().includes(this.search.toLowerCase())) {
                  let itemData = item
                  itemData.category = subCategory
                  searchResults.push(itemData)
                }
              })
            })
          } else {
            category.items.forEach((item) => {
              if (item.name?.toLowerCase().includes(this.search.toLowerCase())) {
                let itemData = item
                itemData.category = category
                searchResults.push(itemData)
              }
            })
          }
        })
        if (searchResults.length > 0) {
          this.searchedItems = searchResults
        } else {
          this.searchedItems = []
        }
      }
    },
    clearSearch() {
      this.search = ''
      this.searchedItems = null
    },
    calculateTimeToHour(h) {
      return ('0' + Math.floor(parseInt(h) / 60)).slice(-2) + ':' + ('0' + (parseInt(h) % 60)).slice(-2)
    },
    getFavorites() {
      const favoritesCategory = this.branding?.display_options?.favorites_category

      if (favoritesCategory?.enabled) {
        const customerId = localStorage.getItem('customerId')
        if (customerId !== null) {
          customersApi.getFavoriteItems(customerId).then((res) => {
            this.favorites = res.data.data
            this.getMenus()
          })
        }
      } else {
        this.favorites = null
      }
    },
    getMenus() {
      let storeId = this.storeId
      if (storeId.includes(' ')) {
        storeId = storeId.replace(' ', '%20')
      }
      let serviceTypeID = localStorage.getItem('selectedServiceId')
      let payload = {
        skip_pick_lists: true,
        service_type_id: serviceTypeID,
      }
      if (this.storeConfig?.enable_menu_filters?.include_out_of_stock) {
        payload.include_out_of_stock = true
      }
      if (!serviceTypeID) {
        delete payload.service_type_id
      }
      if (this.selectedDay && this.selectedHour) {
        let time = this.selectedHour.hour == 'ASAP' ? this.selectedHour.asapTime : this.selectedHour.hour
        payload.ready_ts = this.selectedDay.date + ' ' + time
      }
      menusApi
        .getMenus(this.storeId, payload)
        .then((response) => {
          this.menus = response.data.data
          if (this.branding.display_options?.marketing_box?.enable) {
            let marketing = this.branding.display_options?.marketing_box
            marketing.type = 'marketing'
            if (this.menus[0].categories.length > 0) {
              if (this.menus[0].categories[0].items.length > 3) {
                // push marketing box after the 3rd item
                this.menus[0].categories[0].items.splice(4, 0, marketing)
              } else {
                // push marketing box to the end of the list
                this.menus[0].categories[0].items.push(marketing)
              }
            }
          }
          const customerId = localStorage.getItem('customerId')

          const favoritesCategory = this.branding?.display_options?.favorites_category
          if (favoritesCategory?.enabled) {
            if (customerId !== null && this.getUpdatedFavorites?.length > 0) {
              if (this.getFavoriteCategory()?.items.length > 0) {
                this.menus[0].categories = [this.getFavoriteCategory(), ...this.menus[0].categories]
              }
            }
          }
          this.SET_COOKIES(response.data.cookies)
          let bundledMenu = []
          this.menus.forEach((menu) => {
            menu.available = true
            menu.categories.forEach((category) => {
              if (category.categories?.length != 0) {
                category.categories.forEach((subCategory) => {
                  subCategory.menu_id = menu.menu_id
                  subCategory.hours = menu.hours
                  subCategory.items.forEach((item) => {
                    item.menu_id = menu.menu_id
                  })
                })
              } else {
                category.menu_id = menu.menu_id
                category.hours = menu.hours
                category.items.forEach((item) => {
                  item.menu_id = menu.menu_id
                })
              }
            })
            // if bundle categories is true
            if (this.branding?.display_options?.collapse_menu_categories) {
              menu.categories.forEach((category) => {
                bundledMenu.push(category)
              })
              menu.categories = bundledMenu
            }
          })
          if (
            this.branding.suggestions &&
            this.branding.suggestions.lists &&
            this.branding.suggestions.lists.length > 0
          ) {
            this.suggestions = []
            this.branding.suggestions.lists.forEach((suggestion) => {
              if (suggestion.type == 'temperature') {
                if (suggestion.limit_type == 'less' && this.temperature >= suggestion.limit) {
                  return
                }
                if (suggestion.limit_type == 'more' && this.temperature <= suggestion.limit) {
                  return
                }
              }
              let suggestionItems = []
              if (this.menus.length != 0) {
                this.menus.forEach((menu) => {
                  menu.categories.forEach((category) => {
                    category.items.forEach((item) => {
                      if (item.classes && item.classes[suggestion.class.name]) {
                        // if item is already in the suggestion list, don't add it again
                        if (suggestionItems.find((suggestionItem) => suggestionItem.item_id == item.item_id)) {
                          return
                        }
                        item.category_id = category.category_id
                        suggestionItems.push(item)
                      }
                    })
                  })
                })
                suggestion.items = suggestionItems
                if (suggestion.items.length > 0) {
                  this.suggestions.push(suggestion)
                  this.selectedSuggestionFilter = this.suggestions[0].display_name
                }
              }
            })
            let surprise = this.suggestions.find((suggestion) => suggestion.type == 'surprise')
            if (surprise) {
              this.getSurpriseSuggestions()
            }
          }
          this.activeCategoryId = this.getAvailableMenus[this.selectedMenuIndex]?.categories[0].category_id
          this.selectedMenuIndex = 0
        })
        .catch((error) => {
          console.log(error)
          let toasterData = {
            show: true,
            message: 'Something went wrong. Please try again later',
          }
          this.SET_TOASTER(toasterData)
        })
    },
    checkInnerWidth(innerWidth) {
      if (innerWidth >= 768) {
        this.slidesPerView = 3
      }
      if (innerWidth < 768) {
        this.slidesPerView = 2
      }
      if (innerWidth <= 500) {
        this.slidesPerView = 1
      }
    },
    scrollToCategory(categoryId, index) {
      this.clearSearch()
      this.activeCategoryIndex = index
      let category = document.getElementById(categoryId)
      category.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' })
    },
    updateActiveCategory(event) {
      if (this.searchedItems) return
      let categories
      // check if categories are on top
      if ((this.branding && this.branding.category_placement == 'top') || this.innerWidth <= 768) {
        // get categories
        categories = this.getTopCategories
        // go through categories
        categories.forEach((category) => {
          // get category's position
          let categoryElement = document.getElementById(category.category_id)
          let categoryPosition = categoryElement?.getBoundingClientRect()
          if (categoryPosition?.top <= 310) {
            this.activeCategoryId = category.category_id
            this.activeSubCategoryId = null
          }
        })
        // find category's index
        let categoryIndex = categories.findIndex((cat) => cat.category_id == this.activeCategoryId)
        // only slide if category is not active
        if (this.activeCategoryIndex != categoryIndex) {
          this.activeCategoryIndex = categoryIndex
          this.swiper.slideTo(categoryIndex - 1, 500, false)
        }
      }
      // check if categories are on side
      else {
        // get categories
        categories = this.menus[this.selectedMenuIndex].categories
        // go through categories
        categories.forEach((category) => {
          // check if there are subcategories
          if (category.categories?.length != 0) {
            category.categories.forEach((subCategory) => {
              let subCategoryElement = document.getElementById(subCategory.category_id)
              let subCategoryPosition = subCategoryElement?.getBoundingClientRect()
              if (subCategoryPosition?.top <= 310) {
                this.activeCategoryId = category.category_id
                this.activeSubCategoryId = subCategory.category_id
              }
            })
          } else {
            let categoryElement = document.getElementById(category.category_id)
            let categoryPosition = categoryElement?.getBoundingClientRect()
            if (categoryPosition?.top <= 310) {
              this.activeCategoryId = category.category_id
              this.activeSubCategoryId = null
            }
          }
        })
      }
      // if user scrolled to the bottom of the page, set the last category as active
      let target = event.target
      if (target.scrollHeight - target.scrollTop === target.clientHeight) {
        this.activeCategoryIndex = categories.length - 1
      }
    },
    onSwiper(swiper) {
      this.swiper = swiper
    },
    changeMenu(index) {
      this.selectedMenuIndex = index
      this.swiper.slideTo(0, 500, false)
    },
    getItemData(item, category, mode, from) {
      // if orderData && dayAndTimeSelected false open date and time modal
      if (!this.orderData && !this.dayAndTimeSelected) {
        this.toggleDateAndTimeModal()
        return
      }
      if (from == 'quickAdd') {
        this.quickAddLoadingItemId = item.item_id
        this.fillScreenItemId = item.item_id
        this.qtyLoading = false
      }
      if (from != 'quickAdd') {
        this.showLoader = true
      }
      if (process.env.VUE_APP_GTM_ID && mode == 'add') {
        // GTM track item clicks
        this.trackItemClicks(category, item)
      }
      if (mode == 'edit') {
        this.editItemData = item
        this.editItemData.menu_id = item.menu_id
      } else {
        this.itemModalMode = 'add'
      }
      let storeId = localStorage.getItem('selectedStoreId')
      if (storeId.includes(' ')) {
        storeId = storeId.replace(' ', '%20')
      }
      let time = this.selectedHour.hour == 'ASAP' ? this.selectedHour.asapTime : this.selectedHour.hour
      let payload = {
        ready_ts: this.selectedDay.date + ' ' + time,
      }
      const favoritesCategory = this.branding.display_options.favorites_category

      if (category?.name === favoritesCategory?.title) {
        category.category_id = this.favorites?.find((eachFavorite) => eachFavorite.item_id === item.item_id).cat_id
      }
      menusApi
        .getItem(storeId, item.menu_id, category.category_id, item.item_id, payload)
        .then((response) => {
          this.itemData = response.data.data
          this.SET_COOKIES(response.data.cookies)
          this.itemData.menu_id = item.menu_id
          this.normalizedAddons = this.normalizeAddons(response.data.data)
          if ((from == 'quickAdd' || from == 'deepLink') && this.quickAddable) {
            this.addToCart()
            if (from == 'quickAdd') this.flyToCardItemId = item.item_id
            if (process.env.VUE_APP_GTM_ID || process.env.VUE_APP_GA4_ID) {
              // GTM track add to cart
              this.trackAddToCart(item)
            }
          } else {
            this.fillScreenAnimation = true
            this.showLoader = false
            this.toggleWithAddonsModal()
            setTimeout(() => {
              this.quickAddLoadingItemId = null
              this.flyToCardItemId = null
            }, 300)
          }
        })
        .catch((error) => {
          console.log(error)
          this.showLoader = false
          let toasterData = {
            show: true,
            message: 'Something went wrong. Please try again later',
          }
          this.SET_TOASTER(toasterData)
        })
    },
    addToCart() {
      let itemPayload = {
        menu_id: parseInt(this.itemData.menu_id),
        quantity: 1,
        item_id: this.itemData.item_id,
        category_id: this.itemData.category_id,
        child_items: [],
        comment: '',
        size_id: null,
      }
      let orderId = this.orderData.order.order_id
      let customerId = localStorage.getItem('customerId')
      let payload = {
        customer_id: this.loggedIn ? customerId : localStorage.getItem('guestCustomerId'),
        items: [itemPayload],
      }
      ordersApi
        .addItemToCart(orderId, payload)
        .then((response) => {
          this.SET_ORDER_DATA(response.data.data)
          this.SET_COOKIES(response.data.cookies)
          this.selectedItemId = this.itemData.item_id
          let toasterData = {
            show: true,
            message: 'Item added to cart',
          }
          this.showLoader = false
          this.quickAddLoadingItemId = null
          this.flyToCardItemId = null
          this.SET_ITEM_TOASTER(toasterData)
          // Facebook Pixel AddToCart event
          if (typeof fbq === 'function') {
            fbq('track', 'AddToCart')
          }
        })
        .catch((error) => {
          if (error.response.data.status == 403) {
            let toasterData = {
              show: true,
              message: 'Your session is expired. Please login again.',
            }
            this.SET_TOASTER(toasterData)
            return
          }
          let toasterData = {
            show: true,
            message: 'Something went wrong. Please try again later.',
          }
          this.SET_TOASTER(toasterData)
        })
    },
    calculateFullPrice(item) {
      let itemPrice = item.extended_price
      if (item.child_items) {
        item.child_items.forEach((childItem) => {
          itemPrice += childItem.extended_price
          if (childItem.child_items) {
            childItem.child_items.forEach((childItem) => {
              itemPrice += childItem.extended_price
              if (childItem.child_items) {
                childItem.child_items.forEach((childItem) => {
                  itemPrice += childItem.extended_price
                })
              }
            })
          }
        })
      }
      return itemPrice
    },
    removeItemClicked(item) {
      this.removeItem(item)
    },
    trackRemoveFromCart(item) {
      window.dataLayer.push({ ecommerce: null }) // Clear the previous ecommerce object.
      window.dataLayer.push({
        event: 'remove_from_cart',
        ecommerce: {
          currency: 'USD',
          value: this.calculateFullPrice(item) / 100,
          items: [
            {
              item_id: item.item_id,
              item_name: item.item_name,
              price: this.calculateFullPrice(item) / 100,
              quantity: item.display_quantity,
              location_id: this.selectedStore.name,
            },
          ],
        },
      })
    },
    removeItem(item) {
      let orderId = this.orderData.order.order_id
      ordersApi
        .removeItemFromCart(orderId, item.order_item_id)
        .then((response) => {
          this.qtyLoading = false
          if (process.env.VUE_APP_GTM_ID || process.env.VUE_APP_GA4_ID) {
            // GTM track remove from cart
            this.trackRemoveFromCart(item)
          }
          this.SET_ORDER_DATA(response.data.data)
          let toasterData = {
            show: true,
            message: 'Item removed from cart',
          }
          this.SET_ITEM_TOASTER(toasterData)
          this.SET_COOKIES(response.data.cookies)
        })
        .catch((error) => {
          this.qtyLoading = false
          let toasterData = {
            show: true,
            message: 'Something went wrong. Please try again.',
          }
          this.SET_TOASTER(toasterData)
          console.log(error)
        })
    },
    childItems(child_items) {
      let childItems = []
      if (!child_items || child_items.length == 0) {
        return []
      }
      child_items.forEach((child) => {
        let data = {
          menu_id: child.menu_id,
          size_id: child.item_size_id,
          style_id: child.item_style_id,
          quantity: child.quantity,
          name: child.item_name,
          item_id: child.item_id,
          category_id: child.category_id,
          pick_list_id: child.pick_list_id,
          child_items: this.childItems(child.child_items),
        }
        if (!child.child_items) {
          delete data.child_items
        }
        childItems.push(data)
      })
      return childItems
    },
    generateOrderObject(item, action) {
      let itemObject = {
        menu_id: item.menu_id,
        size_id: item.item_size_id,
        style_id: item.item_style_id,
        quantity: item.quantity,
        item_id: item.item_id,
        category_id: item.category_id,
        categories: item.categories,
        comment: item.comment,
        child_items: this.childItems(item.child_items),
        order_item_id: item.order_item_id,
      }
      if (action == 'editClicked') {
        /* if (!item.child_items && !item.size) {
          this.$emit('openWithOutAddons', itemObject) 
        } */
        this.$emit('openWithAddons', itemObject)
      }
      if (action == 'changeQty') {
        return itemObject
      }
    },
    changeQty(type, item, index) {
      // find the item in this.orderData.order.items
      let orderItem = this.orderData.order.items.find((orderItem) => orderItem.item_id == item.item_id)
      // check max qty of the item
      if (orderItem.max_qty) {
        if (type == 'plus' && orderItem.quantity == orderItem.max_qty) {
          let toasterData = {
            show: true,
            message: 'Maximum quantity you can select is ' + orderItem.max_qty + ' for ' + orderItem.item_name,
          }
          this.SET_TOASTER(toasterData)
          return
        }
      }
      this.qtyLoading = true
      this.selectedItemId = item.item_id
      if (index) {
        this.selectedItemIndex = index
      }
      if (type == 'minus' && orderItem.quantity == 1) {
        this.removeItemClicked(orderItem)
        return
      }
      let orderId = this.orderData.order.order_id
      let customerId = localStorage.getItem('customerId')
      let currentQty = orderItem.quantity
      let newQty
      if (type == 'plus') {
        if (currentQty == 99) {
          this.qtyLoading = false
          let toasterData = {
            show: true,
            message: 'Maximum quantity you can select is 99 for ' + orderItem.item_name,
          }
          this.SET_TOASTER(toasterData)
          return
        }
        newQty = currentQty + 1
      } else {
        newQty = currentQty - 1
      }
      let payload = {
        customer_id: this.loggedIn ? customerId : localStorage.getItem('guestCustomerId'),
        items: [this.generateOrderObject(orderItem, 'changeQty')],
      }
      payload.items[0].quantity = newQty
      payload.items[0].order_item_id = orderItem.order_item_id
      payload.items[0].child_items.forEach((childItem) => {
        let childItemQuantityForOne = childItem.quantity / currentQty
        if (type == 'plus') {
          childItem.quantity = childItemQuantityForOne * (currentQty + 1)
        } else {
          childItem.quantity = childItemQuantityForOne * (currentQty - 1)
        }
        if (childItem.child_items) {
          childItem.child_items.forEach((childChildItem) => {
            let childChildItemQuantityForOne = childChildItem.quantity / currentQty
            if (type == 'plus') {
              childChildItem.quantity = childChildItemQuantityForOne * (currentQty + 1)
            } else {
              childChildItem.quantity = childChildItemQuantityForOne * (currentQty - 1)
            }
          })
        }
      })
      ordersApi
        .changeItemQuantity(orderId, payload)
        .then((response) => {
          this.qtyLoading = false
          this.selectedItemId = null
          this.selectedItemIndex = null
          this.SET_ORDER_DATA(response.data.data)
          this.SET_COOKIES(response.data.cookies)
        })
        .catch(() => {
          this.qtyLoading = false
          this.selectedItemId = null
          this.selectedItemIndex = null
          let toasterData = {
            show: true,
            message: 'Something went wrong. Please try again later.',
          }
          this.SET_TOASTER(toasterData)
        })
    },
    getTemperature() {
      externalApi
        .getWeather(this.selectedStore.latitude, this.selectedStore.longitude)
        .then((response) => {
          this.temperature = response.data.current_weather.temperature
        })
        .catch((error) => {
          console.log(error)
        })
    },
    openUpsellItem(item, category) {
      this.getItemData(item, category, 'add')
    },
    updateTitle() {
      let title = localStorage.getItem('selectedStoreName') || this.selectedStore?.name
      if (title) {
        document.title = `${this.baseTitle} - ${title}`
      }
    },
    foreignAuthLoginIfNeeded() {
      if (this.loggedIn) {
        return
      }
      const query = new URLSearchParams(window.location.search)
      const provider = query.get('auth_provider')
      const token = query.get('auth_access_token')

      if (provider && token) {
        const payload = {
          provider: provider,
          auth_info: {
            access_token: token,
          },
        }
        customersApi
          .foreignAuth(payload)
          .then((response) => {
            localStorage.setItem('customerId', response.data.data.customer_id)
            this.SET_COOKIES(response.data.cookies)
            this.getCustomerInfo()
          })
          .catch((error) => {
            console.log(error)
            this.$emit('ssoError')
          })
      }
    },
    getCustomerInfo() {
      this.SET_BUTTON_LOADER(true)
      customersApi
        .getCustomerInfo()
        .then((response) => {
          let toasterData = {
            show: true,
            message: 'Welcome back',
          }
          this.SET_TOASTER(toasterData)
          this.SET_CUSTOMER_DATA(response.data.data)
          // for FullStory
          this.identifyUser(response.data.data)
          this.SET_PHONE_VERIFIED(response.data.data.is_phone_verified)
          localStorage.setItem('phoneVerified', response.data.data.is_phone_verified)
          this.SET_LOGGED_IN(true)
          this.SET_BUTTON_LOADER(false)
          this.SET_COOKIES(response.data.cookies)
        })
        .catch((error) => {
          console.log(error)
        })
    },
  },
  created() {
    let selectedStoreId = localStorage.getItem('selectedStoreId')
    let currentStoreId = this.$route.params.storeId
    if (selectedStoreId != currentStoreId) {
      this.SET_ORDER_DATA(null)
      localStorage.removeItem('dayAndTimeSelected')
      this.SET_DAY_AND_TIME_SELECTED(false)
      localStorage.removeItem('selectedDay')
      this.SET_SELECTED_DAY(null)
      localStorage.removeItem('selectedHour')
      this.SET_SELECTED_HOUR(null)
      localStorage.removeItem('selectedTip')
      localStorage.removeItem('tipSelected')
      localStorage.removeItem('selectedStoreId')
      this.SET_SELECTED_ADDRESS(null)
      localStorage.removeItem('selectedAddress')
    }

    this.checkInnerWidth(window.innerWidth)
    window.addEventListener('resize', () => {
      const innerWidth = window.innerWidth
      this.checkInnerWidth(innerWidth)
    })
    if (this.selectedStore) {
      this.getTemperature()
    }
    this.storeId = this.$route.params.storeId
    const customerId = localStorage.getItem('customerId')
    if (customerId !== null) {
      this.getFavorites()
    }
    this.getMenus()
    if (localStorage.getItem('dayAndTimeSelected')) {
      this.dateAndTimeModalIsOpen = false
    }

    window.addEventListener('resize', () => {
      const innerWidth = window.innerWidth
      this.innerWidth = innerWidth
    })
  },
  mounted() {
    // if filterDropdown is open, close it when user clicks outside of it
    document.addEventListener('click', (e) => {
      if (this.filterDropdownIsOpen) {
        if (!this.$refs.filterDropdown.contains(e.target)) {
          this.filterDropdownIsOpen = false
        }
      }
    })
    // add event listener for window resize
    window.addEventListener('resize', () => {
      this.windowWidth = window.innerWidth
    })

    // if there is an active order and deepLinkItemId, add it to the cart
    let deepLinkItemId = localStorage.getItem('deepLinkItemId')
    if (this.orderData && deepLinkItemId) {
      this.addDeepLinkItemToCart()
    }
    this.updateTitle()
    this.foreignAuthLoginIfNeeded()
  },
  beforeUnmount() {
    // remove event listener when component is destroyed
    document.removeEventListener('click', (e) => {
      if (this.filterDropdownIsOpen) {
        if (!this.$refs.filterDropdown.contains(e.target)) {
          this.filterDropdownIsOpen = false
        }
      }
    })
    // remove event listener for window resize
    window.removeEventListener('resize', () => {
      this.windowWidth = window.innerWidth
    })
  },
}
</script>

<style src="../assets/css/views/MenuView.css" scoped></style>